export const primary = "#13e6d8";
export const secondary = "#180136";
export const neutral = "rgb(232, 229, 232)";

export const divergingScheme1 = [
  "#424269",
  "#00AAFF",
  "#13E6D8",
  "#6EC020",
  "#00FFFF",
  "#D9E021",
  "#FFE100",
  "#F7B82B",
  "#F15A24",
  "#DD1F4E",
  "#AC20B4",
  "#4820B4",
];

export const divergingScheme2 = [
  "#424269",
  "#00AAFF",
  "#13E6D8",
  "#6EC020",
  "#00FFFF",
  "#D9E021",
  "#FFE100",
  "#F7B82B",
  "#F15A24",
  "#DD1F4E",
  "#AC20B4",
  "#4820B4",
];

export const divergingScheme3 = [
  "#424269",
  "#00AAFF",
  "#13E6D8",
  "#6EC020",
  "#00FFFF",
  "#D9E021",
  "#FFE100",
  "#F7B82B",
  "#F15A24",
  "#DD1F4E",
  "#AC20B4",
  "#4820B4",
];

export const divergingScheme4 = [
  "#424269",
  "#00AAFF",
  "#13E6D8",
  "#6EC020",
  "#00FFFF",
  "#D9E021",
  "#FFE100",
  "#F7B82B",
  "#F15A24",
  "#DD1F4E",
  "#AC20B4",
  "#4820B4",
];

export const duo = [
  "#424269",
  "#00AAFF",
];

export const getColor = (colors: string[], index: number, totalValues?: number): string =>
  totalValues !== void 0 && totalValues < colors.length / 2
    ? colors[(index * Math.max(Math.floor(colors.length / totalValues), 1)) % colors.length]
    : colors[index % colors.length];
